export class RawData {
  gridApi: any = null;
  gridApiItems: any = null;
  datasets: any[] = [];
  selectedDataset: any = null;
  dataset: any = null;
  selectedItem: any = null;
  imgData: any = null;
  itemDetails: string = '';
}